import styled from 'styled-components';

export const ContainerStyled = styled.span`
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;

  padding-left: 8px;
`;
